import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad händer om jag får en anmärkning vid tillsyn?";
const SHORT_ANSWER = "Lindriga avvikelser leder ofta till erinran eller varning. Vid allvarligare brister kan kommunen ta ut sanktionsavgift eller återkalla tillståndet.";

export const Route = createFileRoute("/fraga/vad-hander-om-jag-far-en-anmarkning")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad händer om jag får en anmärkning vid tillsyn" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Anmärkningar dokumenteras och vägs samman över tid. Mönster av återkommande brister leder snabbt till varning även om enskilda fall är små."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Sanktioner och påföljder" }}
      related={[{"to": "/fraga/hur-overklagar-jag-ett-beslut", "label": "Hur överklagar jag ett beslut om serveringstillstånd?"}, {"to": "/fraga/nar-leder-sanktionsavgift", "label": "Vad är en sanktionsavgift och när tas den ut?"}, {"to": "/fraga/vad-galler-vid-tillsynsbesok", "label": "Vad gäller vid ett tillsynsbesök?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad händer om jag får en anmärkning vid tillsyn?" },
      { name: "description", content: "Lindriga avvikelser leder ofta till erinran eller varning. Vid allvarligare brister kan kommunen ta ut sanktionsavgift eller återkalla tillståndet." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-hander-om-jag-far-en-anmarkning" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-hander-om-jag-far-en-anmarkning" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-hander-om-jag-far-en-anmarkning",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad händer om jag får en anmärkning vid tillsyn", url: "https://alkoholprovet.se/fraga/vad-hander-om-jag-far-en-anmarkning" },
      ]),
    ],
  }),
});
